/* Parent Hax — Theme JS */
'use strict';

/* Everything below runs inside this IIFE so nothing leaks onto `window`
   except the one deliberate bridge value Liquid sets (`window.PHMailchimp`,
   assigned in layout/theme.liquid) — `phMailchimpSubscribe` itself used to
   be a bare top-level `function`, which (since this file loads as a plain
   classic <script>, not a module) put it on the global object even though
   nothing outside this file ever calls it. */
(function () {

/* ── Mailchimp JSONP subscribe ──────────────────────────────── */
function phMailchimpSubscribe(email, fname, lname) {
  var base = window.PHMailchimp;
  if (!base || !email) return;
  var url = base.replace('/post?', '/post-json?');
  url += '&EMAIL=' + encodeURIComponent(email);
  if (fname) url += '&FNAME=' + encodeURIComponent(fname);
  if (lname) url += '&LNAME=' + encodeURIComponent(lname);
  var cbName = '__mc_cb_' + Date.now();
  url += '&c=' + cbName;
  window[cbName] = function() { delete window[cbName]; };
  var s = document.createElement('script');
  s.src = url;
  s.onerror = function() { s.parentNode && s.parentNode.removeChild(s); };
  document.head.appendChild(s);
  setTimeout(function() { s.parentNode && s.parentNode.removeChild(s); }, 6000);
}

document.addEventListener('DOMContentLoaded', () => {

  /* ── Scroll reveal ──────────────────────────────────────── */
  const revealEls = document.querySelectorAll('.reveal, .reveal-left, .reveal-right');
  if (revealEls.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    revealEls.forEach((el) => observer.observe(el));
  } else {
    // Fallback: show everything immediately
    revealEls.forEach((el) => el.classList.add('is-visible'));
  }

  /* ── AJAX form submission ────────────────────────────────── */
  document.querySelectorAll('.ph-ajax-form').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      const submitBtn = form.querySelector('[type="submit"]');
      const wrap      = form.closest('.ph-form-wrap');
      const successEl = wrap && wrap.querySelector('.form-success');
      const origText  = submitBtn.textContent.trim();

      // Honeypot: real visitors never see or fill this field. If it has a
      // value, a bot filled it — show success without ever hitting the network,
      // so the bot moves on and neither the store owner nor Mailchimp sees it.
      const honeypot = form.querySelector('.hp-field');
      if (honeypot && honeypot.value.trim() !== '') {
        if (successEl) {
          form.style.display      = 'none';
          successEl.style.display = 'block';
        }
        return;
      }

      submitBtn.disabled    = true;
      submitBtn.textContent = 'Sending…';

      try {
        // Accept: application/json lets Formspree respond without a redirect;
        // Shopify's contact form ignores it and still returns its usual response.
        await fetch(form.action || window.location.pathname, {
          method:  'POST',
          body:    new FormData(form),
          headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
        });

        // If fetch didn't throw, the submission was accepted.
        // Only subscribe to Mailchimp for forms that explicitly opt in via
        // the mailchimp-opt-in class (e.g. the wholesale enquiry modal) —
        // a plain contact message is not consent to join the marketing list.
        if (form.classList.contains('mailchimp-opt-in')) {
          const emailEl = form.querySelector('[name="contact[email]"]');
          const fnameEl = form.querySelector('[name="contact[first_name]"]');
          const lnameEl = form.querySelector('[name="contact[last_name]"]');
          phMailchimpSubscribe(
            emailEl ? emailEl.value.trim() : '',
            fnameEl ? fnameEl.value.trim() : '',
            lnameEl ? lnameEl.value.trim() : ''
          );
        }

        if (successEl) {
          form.style.display      = 'none';
          successEl.style.display = 'block';
        } else {
          submitBtn.textContent      = 'Sent ✓';
          submitBtn.style.background = '#22c55e';
          submitBtn.style.color      = 'white';
        }
      } catch {
        submitBtn.disabled    = false;
        submitBtn.textContent = origText;
        // Show a friendly inline error
        // Audit fix: #e53e3e measures ~4.12:1 on white — fails the 4.5:1 AA
        // minimum for .85rem (~13.6px) normal-weight text. #B91C1C measures
        // ~6.47:1, comfortably passing, still clearly "error red".
        const errEl = document.createElement('p');
        errEl.style.cssText = 'color:#B91C1C;font-size:.85rem;margin-top:.5rem;';
        errEl.textContent   = 'Something went wrong — please try again.';
        form.appendChild(errEl);
        setTimeout(() => errEl.remove(), 4000);
      }
    });
  });

});

/* ── Qty +/− buttons ───────────────────────────────────── */
document.addEventListener('click', (e) => {
  const btn = e.target.closest('.qty-btn');
  if (!btn) return;
  const input = btn.closest('.qty-wrap').querySelector('.qty-input');
  if (!input) return;
  const min = parseInt(input.min || '0', 10);
  let val = parseInt(input.value, 10) || 1;
  if (btn.dataset.action === 'plus') val += 1;
  if (btn.dataset.action === 'minus') val = Math.max(min, val - 1);
  input.value = val;
  input.dispatchEvent(new Event('change', { bubbles: true }));
});

/* Product gallery thumbnail swap — removed 2026-07-31. All four PDP
   templates now use the Top N Tail vertical-image-stack gallery
   (.product-gallery--scroll, no click-to-swap thumbnails), so
   .product-gallery__thumb no longer exists anywhere in the theme. */

/* ── Product variant selection (sections/product-page.liquid) ─────────
   The option radios only ever toggled their own checked/is-selected state
   — nothing updated the hidden `id` input, the displayed price, or the
   Add to Cart button, so submitting the form always added whichever
   variant the page happened to load with. `ProductVariantsJson` (rendered
   by the section) carries each variant's id/price/availability/image so
   this can find the matching variant and reflect it in the UI. */
document.addEventListener('change', (e) => {
  if (!e.target.classList || !e.target.classList.contains('js-variant-option')) return;

  const variantsEl = document.getElementById('ProductVariantsJson');
  const idInput    = document.getElementById('ProductSelectedVariantId');
  if (!variantsEl || !idInput) return;

  let variants;
  try {
    variants = JSON.parse(variantsEl.textContent);
  } catch {
    return;
  }

  // Selected value per option position (1-based, matches variant.options order).
  const selected = [];
  document.querySelectorAll('.product-option').forEach((group) => {
    const checked = group.querySelector('.js-variant-option:checked');
    const position = parseInt(group.dataset.optionPosition, 10);
    if (checked && position) selected[position - 1] = checked.value;
  });

  const variant = variants.find((v) =>
    v.options.length === selected.length && v.options.every((val, i) => val === selected[i])
  );

  const priceEl      = document.getElementById('ProductPrice');
  const compareEl    = document.getElementById('ProductComparePrice');
  const saleBadgeEl  = document.getElementById('ProductSaleBadge');
  const addToCartBtn = document.getElementById('AddToCartButton');
  const addToCartTxt = document.getElementById('AddToCartButtonText');
  const mainImg      = document.getElementById('MainProductImage');

  if (!variant) {
    // No variant matches this combination — disable purchase rather than
    // let the form submit whatever `id` it last had (a different, wrong,
    // possibly-unavailable variant).
    idInput.value = '';
    if (addToCartBtn) {
      addToCartBtn.disabled = true;
      addToCartBtn.classList.remove('btn--yellow');
      addToCartBtn.classList.add('btn--black');
      addToCartBtn.style.opacity = '.55';
      addToCartBtn.style.cursor  = 'not-allowed';
    }
    if (addToCartTxt && addToCartBtn) addToCartTxt.textContent = addToCartBtn.dataset.unavailableLabel;
    return;
  }

  idInput.value = variant.id;
  if (priceEl) priceEl.textContent = variant.price_formatted;

  if (compareEl) compareEl.style.display = variant.on_sale ? '' : 'none';
  if (saleBadgeEl) saleBadgeEl.style.display = variant.on_sale ? '' : 'none';
  if (compareEl && variant.on_sale) compareEl.textContent = variant.compare_at_price_formatted;

  if (addToCartBtn) {
    addToCartBtn.disabled = !variant.available;
    addToCartBtn.classList.toggle('btn--yellow', variant.available);
    addToCartBtn.classList.toggle('btn--black', !variant.available);
    addToCartBtn.style.opacity = variant.available ? '' : '.55';
    addToCartBtn.style.cursor  = variant.available ? '' : 'not-allowed';
    if (addToCartTxt) {
      addToCartTxt.textContent = variant.available
        ? addToCartBtn.dataset.addToCartLabel + ' — ' + variant.price_formatted
        : addToCartBtn.dataset.soldOutLabel;
    }
  }

  if (variant.featured_image && mainImg) mainImg.src = variant.featured_image;
});

/* ── Blog article "copy link" share button ─────────────────────────────
   Was a literal onclick="…" HTML attribute — functionally fine, but
   inline event-handler attributes are exactly what a strict
   Content-Security-Policy (script-src without 'unsafe-inline') blocks,
   unlike <script> tags which can be allow-listed via nonce/hash. Moved to
   a delegated listener, same behavior, CSP-friendly. */
document.addEventListener('click', (e) => {
  const btn = e.target.closest('.share-btn--copy');
  if (!btn || !btn.dataset.copyUrl) return;
  // Audit fix: the colour-only .is-copied state gave no feedback to screen
  // reader users. The status span (sr-only, aria-live="polite") announces
  // the result out loud without changing anything visually.
  const statusEl = btn.closest('.article-content__share') &&
    btn.closest('.article-content__share').querySelector('[data-copy-status]');
  navigator.clipboard.writeText(btn.dataset.copyUrl).then(() => {
    btn.classList.add('is-copied');
    if (statusEl) statusEl.textContent = 'Link copied to clipboard';
    setTimeout(() => {
      btn.classList.remove('is-copied');
      if (statusEl) statusEl.textContent = '';
    }, 2000);
  }).catch(() => {
    // Clipboard API can fail (permissions, insecure context) — fail silently
    // rather than throw; the link itself is still visible/selectable on the page.
    if (statusEl) statusEl.textContent = 'Could not copy link';
  });
});

})();
